/* --------------------------------------------------------------------------
 * Shared line icons. They inherit colour from the parent via currentColor,
 * so they work in both themes without a variant per icon.
 * ----------------------------------------------------------------------- */

const DEFAULT_SIZE = 'h-[14px] w-[14px] shrink-0';

const strokeProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.7',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
};

export const PhoneIcon = ({ className = DEFAULT_SIZE }) => (
  <svg className={className} {...strokeProps}>
    <path d="M21.5 16.9v2.4a1.6 1.6 0 0 1-1.75 1.6 15.9 15.9 0 0 1-6.93-2.47 15.6 15.6 0 0 1-4.8-4.8A15.9 15.9 0 0 1 5.55 6.7 1.6 1.6 0 0 1 7.14 4.95h2.4a1.6 1.6 0 0 1 1.6 1.38c.1.77.29 1.52.56 2.23a1.6 1.6 0 0 1-.36 1.69l-1.02 1.01a12.8 12.8 0 0 0 4.8 4.8l1.01-1.01a1.6 1.6 0 0 1 1.69-.36c.71.27 1.46.46 2.23.56a1.6 1.6 0 0 1 1.38 1.62Z" />
  </svg>
);

export const MailIcon = ({ className = DEFAULT_SIZE }) => (
  <svg className={className} {...strokeProps}>
    <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
    <path d="m3 6.5 8.2 5.7a1.5 1.5 0 0 0 1.6 0L21 6.5" />
  </svg>
);

export const LinkedInIcon = ({ className = DEFAULT_SIZE }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M4.98 3.5A2.5 2.5 0 1 1 2.5 6 2.49 2.49 0 0 1 4.98 3.5ZM3 8.98h4v12H3ZM9.5 8.98h3.83v1.64h.05a4.2 4.2 0 0 1 3.78-2.08c4.04 0 4.79 2.66 4.79 6.12v6.32h-4v-5.6c0-1.34-.02-3.06-1.87-3.06s-2.15 1.46-2.15 2.96v5.7h-4Z" />
  </svg>
);
